import { makeStyles, createStyles } from "@material-ui/core/styles";


export default makeStyles(() =>
    createStyles({
        root: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
        },
    }),
);
